import React from "react";
import { 
  FiSettings, 
  FiSliders, 
  FiShield, 
  FiBell, 
  FiLock,
  FiClock,
  FiSave
} from "react-icons/fi";

export function RcaSettingsPage() {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm flex flex-wrap items-center justify-between gap-4">
        <div>
          <div className="text-xs font-semibold text-blue-600 uppercase tracking-wider">CMTS &gt; Module Configuration</div>
          <h1 className="text-xl font-bold text-slate-900 mt-1">RCA Module Settings & Governance</h1>
          <p className="text-xs text-slate-500 mt-1">
            Configure SLA thresholds, enabled RCA methods, separation-of-duties rules, and automated FMEA hooks.
          </p>
        </div>

        <button
          type="button"
          className="px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-semibold text-xs rounded-lg shadow-sm flex items-center gap-2"
        >
          <FiSave className="w-4 h-4" />
          Save Configurations
        </button>
      </div>

      {/* Settings Sections */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm space-y-4">
          <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2">
            <FiClock className="w-4 h-4 text-blue-600" /> Investigation SLA Thresholds
          </h3>
          <div className="space-y-3 text-xs">
            <div>
              <label className="block text-slate-600 font-semibold mb-1">Standard Investigation SLA (Days):</label>
              <input type="number" defaultValue={7} className="w-full p-2.5 rounded-lg border border-slate-300 bg-white text-slate-900 font-bold focus:ring-2 focus:ring-blue-500" />
            </div>
            <div>
              <label className="block text-slate-600 font-semibold mb-1">Critical Escalation Warning (Days remaining):</label>
              <input type="number" defaultValue={2} className="w-full p-2.5 rounded-lg border border-slate-300 bg-white text-slate-900 font-bold focus:ring-2 focus:ring-blue-500" />
            </div>
          </div>
        </div>

        <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm space-y-4">
          <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2">
            <FiShield className="w-4 h-4 text-blue-600" /> SoD Enforcement & Quality Gates
          </h3>
          <div className="space-y-3 text-xs">
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" defaultChecked className="rounded border-slate-300 text-blue-600 focus:ring-blue-500" />
              <span className="font-semibold text-slate-800">Enforce Separation-of-Duties (RCA Owner cannot approve own RCA)</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" defaultChecked className="rounded border-slate-300 text-blue-600 focus:ring-blue-500" />
              <span className="font-semibold text-slate-800">Require SHA-256 Antivirus Check on all Evidence uploads</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" defaultChecked className="rounded border-slate-300 text-blue-600 focus:ring-blue-500" />
              <span className="font-semibold text-slate-800">Require High Action Priority (AP) FMEA Feedback link on closure</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
